import { render, staticRenderFns } from "./tap-general-customer.vue?vue&type=template&id=20dd8022"
import script from "./tap-general-customer.vue?vue&type=script&lang=js"
export * from "./tap-general-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports